const cet = { standard: 'HNEC', dst: 'HAEC' };

export default {
  Europe: {
    Amsterdam: cet,
    Berlin: cet,
    Brussels: cet,
    Copenhagen: cet,
    Oslo: cet,
    Paris: cet,
    Stockholm: cet,
  },
};
